export const formatCurrencyStringToNumber = (value: string) => {
  if (!value || typeof value !== "string") {
    return 0;
  }

  // Remove all commas, keeping only digits and decimal point, then convert to number
  return Number(value.replace(/[,]/g, "")) ?? 0;
};
